import { Data2, newId } from '../../../features/data-types'
import { useSystemStateHooks } from '../../system'
import { CashFund, CashFundType } from '../state/types'
import { Currency } from '../../../tables/types/types'

export const useCashFundBuilders = () => {
    const { companyId } = useSystemStateHooks()

    const buildCashFund = (data: Data2) => {
        const { id = newId(), name, type, availableAmount, reservedAmount, archived } = data
        const cashFund: CashFund = {
            companyId: companyId!,
            id: id! as string,
            name: name! as string,
            type: type! as CashFundType,
            availableAmount: availableAmount! as number,
            reservedAmount: reservedAmount! as number,
            currency: Currency.ARS,
            archived: !!archived
        }

        return cashFund
    }

    return {
        buildCashFund
    }
}
